import React, { useState } from 'react';
import { get as _get } from 'lodash-es';

const ProductAddToCart = ({
  _addButtonTitle,
  _singleProduct,
  _variantId,
  _baseItemId,
  handleAdd,
  isAlreaydAdded,
  setLoading,
}) => {
  //  const handleAddClick = singleProduct => {
  // CompatioAnalytics.track(CompatioAnalytics.events.xrsAddToCartClick, {
  //   variant_id: singleProduct.merchantProductSku,
  //   product_name: singleProduct.productName,
  //   click_action: CompatioAnalytics.clicks.xrsAddToCart,
  // });
  //};

  return (
    <a
      id={`AddToCart-${_variantId}`}
      data-baseitemid={_baseItemId}
      className="dc-outfit-button"
      data-section-id={_variantId}
      data-product-handle={_singleProduct.productHandle}
      data-product-url={_singleProduct.url_product}
      onClick={() => {
        handleAdd(_singleProduct);
        // console.log(_singleProduct, '_singleProduct');
        // setLoading(true);
      }}
    >
      {/* {isAlreaydAdded ? 'Remove' : _addButtonTitle} */}
      {_addButtonTitle}
    </a>
  );
};

export default ProductAddToCart;
